import { useHotkeys } from "react-hotkeys-hook";

// List navigation shared by index/list scenes: ↑/↓ (also while typing in the search box)
// and J/K (only outside inputs, so they can be typed), Enter to open the selection.
// onOpen receives { newTab } so ⌘Enter can open in a new browser tab.
const useListShortcuts = ({ onUp, onDown, onOpen, enabled = true }, deps) => {
  useHotkeys("down", onDown, { enabled, enableOnFormTags: true, preventDefault: true }, deps);
  useHotkeys("up", onUp, { enabled, enableOnFormTags: true, preventDefault: true }, deps);
  useHotkeys("j", onDown, { enabled, preventDefault: true }, deps);
  useHotkeys("k", onUp, { enabled, preventDefault: true }, deps);
  useHotkeys("enter", () => onOpen({ newTab: false }), { enabled, enableOnFormTags: true, preventDefault: true }, deps);
  useHotkeys("mod+enter", () => onOpen({ newTab: true }), { enabled, enableOnFormTags: true, preventDefault: true }, deps);
};

export default useListShortcuts;
